import { isRunningOnServer } from "@snapchat/web-env";
export function isProd() {
    if (isRunningOnServer()) {
        return process.env.STAGE === "production";
    }
    return window.location.hostname.endsWith(".snapchat.com");
}
export const SNAPCHAT_TOPLEVEL_DOMAIN = isProd() ? "snapchat.com" : "snap-dev.net";
export const SNAPCHAT_HOST = `www.${SNAPCHAT_TOPLEVEL_DOMAIN}`;
export const LENS_DATA_SOURCE_NAME = process.env.NEXT_PUBLIC_SENTRY_DSN ||
    "https://dd9355fd374d48a6a5abec6ccef8a1e8@sentry.sc-prod.net/136";
export const LENS_ORIGIN = "https://lens.snapchat.com";
export const SENTRY_CSP_URI = process.env.STAGE === "production" ? LENS_DATA_SOURCE_NAME : "";
